import type { WidgetChannel } from '../types/bridge';

/**
 * Canonical channel is only `web_widget` | `mobile_webview`.
 * URL aliases: web / omitted → web_widget; webview → mobile_webview.
 */
export function parseWidgetChannel(
  raw: string | null | undefined,
): WidgetChannel {
  const value = (raw || '').trim().toLowerCase();
  if (value === 'webview' || value === 'mobile_webview') return 'mobile_webview';
  return 'web_widget';
}
